/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadingFour = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 6v12h2v-5h6v5h2V6h-2v5H5V6zm12.009 8.928v1.44h4.02V18h1.776v-1.632h1.2v-1.56h-1.2V9.396h-1.668zm4.068-3.048v2.472l-.036.456h-2.1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeadingFour as HeadingFour };
